import type { PropsWithChildren } from 'react'

import { ErrorBoundary } from 'react-error-boundary'

import { LoadingOverlay } from 'components/Loading'
import { useAppContext } from 'context/AppContext'
import { CatchAllFullpage } from 'views/errors/CatchAll'

/**
 * Loader component, also checks if the event is locked
 * and shows the locked screen if it is
 */
export const Loader = ({ children }: PropsWithChildren): JSX.Element => {
  const { loadFailure, contentLoaded } = useAppContext()

  // Show loading while content is loading
  if (!contentLoaded && !loadFailure) {
    return <LoadingOverlay />
  }

  // Show error if content failed to load
  if (loadFailure) {
    return <CatchAllFullpage />
  }

  // Show normal content if unlocked and loaded
  return (
    <ErrorBoundary FallbackComponent={CatchAllFullpage}>
      {children}
    </ErrorBoundary>
  )
}
